import {RequestFactory} from "@/requests/RequestFactory";
const usuarioRequest = RequestFactory.get("usuario");

//initial state
const state = {
    usuarios: [],
    usuario: null,
    items: {}
}

// mutations
const mutations = {
    SET_USUARIO(state, usuario) {
        state.usuario = usuario
    },

    SET_USUARIOS(state, usuarios) {
        state.usuarios = usuarios
    },

    ADD_USUARIO(state, usuario) {
        state.usuarios.push(usuario)
    },

    DELETE_USUARIO(state, id) {
        var i = state.usuarios.findIndex(usuario => usuario.id == id)
        state.usuarios.splice(i, 1)
    },

}

// actions
const actions = {
    fetchAllUsuarios: ({ dispatch }) => dispatch('fetchAllItems', { resource: 'usuario' }, { root: true }),
    
    addUsuario({ commit, dispatch }, userData) {
        let notification = {}
        usuarioRequest.post(userData)
            .then((response) => {
                notification = {
                    type: 'success',
                    mensagem: "Cadastro realizado com sucesso"
                }

                const payload = { resource: 'usuario', item: response.data }
                commit('setItem', payload, { root: true })                
            })
            .catch((error) => {
                notification = {
                    type: 'error',
                    mensagem: error
                }
            })

        //commit('ADD_USUARIO', userData)
        dispatch('notification/add', notification, { root: true })
    },

    editUsuario({ commit, dispatch }, userData) {
        usuarioRequest.put(userData).then((response) => {
            const payload = { resource: 'usuario', item: response.data }
            commit('setItem', payload, { root: true })                  

            let notification = {
                type: 'success',
                message: 'Usuário editado com sucesso'
            }
            dispatch('notification/add', notification, { root: true })
        });
    },

    deleteUsuario({ commit, dispatch }, usuarioId) {
        usuarioRequest.delete(usuarioId).then(() => { 
            const payload = { resource: 'usuario', itemId: usuarioId }
            commit('deleteItem', payload, { root: true })
        });
        const notification = {
            type: 'success',
            message: 'Usuário removido com sucesso'
        }

        dispatch('notification/add', notification, { root: true })
    },    

    getUsuario({commit}) {
        return usuarioRequest.getUsuario().then(function (result) {
            commit('SET_USUARIO', result.data);
            return result.data
        });
    },

    redefinirSenha({ dispatch }, usuarioId) {
        usuarioRequest.postRedefinirSenha(usuarioId).then( response => {          
            response;
            let notification = {
                type: 'success',
                mensagem: "Cadastro realizado com sucesso"
            }
            dispatch('notification/add', notification, { root: true })

        });
    },

    getUsuarioById({commit}, id) {
        usuarioRequest.getUsuarioById(id).then(function (result) {
            commit('SET_USUARIO', result.data);
        });
        return state.usuario
    },


    getAll(context) {
        usuarioRequest.getAll().then(function (result) {
            context.commit('SET_USUARIOS', result.data);
        })
    },

    getMsgEmail(email) {
        return usuarioRequest.getMsgEmail(email);
    },

    editSenha({ dispatch }, userData) {
        usuarioRequest.putSenha(userData).then(() => { });
        let notification = {
            type: 'success',
            message: 'Usuário editado com sucesso'
        }
        dispatch('notification/add', notification, { root: true })
    },

    novaSenha({ commit }, token) {
        commit("", "")
        return usuarioRequest.postSenha(token);
    },
}

// getters
const getters = {
    all: state => {
        return state.items ? Object.values(state.items) : []
    },

    getUser(state) {
        var user = Object.values(state.items).find(u => u.id === state.usuario.id)

        if(user) {
            return user
        }
        return state.usuario;
    },

    getUsuarioAutenticado(state) {
        return state.usuario;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}


